import { Component, ChangeDetectorRef, ElementRef, TemplateRef, Injectable, Injector, InjectionToken, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NgbActiveModal, NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { Type, Str } from '@wke/ucc-angular-alt-common';
import { ComponentPortal, PortalInjector, PortalModule } from '@angular/cdk/portal';
import { NavigationEnd, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IconModule } from '@wke/ucc-icons';
import { ProgressButtonModule } from '@wke/ucc-angular-alt-buttons';

/** Referencia a la declaración de la modal */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@wke/ucc-icons';
import * as ɵngcc4 from '@angular/cdk/portal';
import * as ɵngcc5 from '@wke/ucc-angular-alt-buttons';
import * as ɵngcc6 from '@angular/router';

function ModalContainerComponent_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "span", 17);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.description);
} }
function ModalContainerComponent_div_1_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵlistener("click", function ModalContainerComponent_div_1_button_10_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.modalRef.dismiss("Cross click"); });
    ɵngcc0.ɵɵelement(1, "ucc-icon", 19);
    ɵngcc0.ɵɵelementEnd();
} }
function ModalContainerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelement(2, "ucc-icon", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 10);
    ɵngcc0.ɵɵelement(4, "ucc-icon", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 12);
    ɵngcc0.ɵɵelementStart(6, "div", 13);
    ɵngcc0.ɵɵelementStart(7, "span", 14);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, ModalContainerComponent_div_1_div_9_Template, 3, 1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, ModalContainerComponent_div_1_button_10_Template, 2, 0, "button", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.canClose);
} }
function ModalContainerComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ModalContainerComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵtemplate(1, ModalContainerComponent_div_3_ng_container_1_Template, 1, 0, "ng-container", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.contentTemplate)("ngTemplateOutletContext", ctx_r1.contextTemplate);
} }
function ModalContainerComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementContainerStart(1, 23);
    ɵngcc0.ɵɵlistener("attached", function ModalContainerComponent_div_4_Template_ng_container_attached_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onContentComponentAttached($event); });
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx_r2.contentComponent);
} }
function ModalContainerComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵelementStart(1, "span", 25);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.contentText);
} }
function ModalContainerComponent_div_6_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵlistener("click", function ModalContainerComponent_div_6_button_1_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r15); const button_r13 = restoredCtx.$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onButtonClick(button_r13); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const button_r13 = ctx.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", button_r13.id ? button_r13.id : "")("ngWKProgressButton", ctx_r12.onButtonIsLoading(button_r13))("disabled", ctx_r12.onButtonIsDisable(button_r13))("ngClass", button_r13.style);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r12.getButtonContent(button_r13.content));
} }
function ModalContainerComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵtemplate(1, ModalContainerComponent_div_6_button_1_Template, 2, 5, "button", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.buttons);
} }
class NgwkModalRef {
    /** @ignore */
    constructor(_ngbModalRef) {
        this._ngbModalRef = _ngbModalRef;
        this._isAlive = true;
    }
    /**
     * Se utiliza para cerrar una modal, pasando un resultado de manera opcional
     */
    close(result) {
        this._isAlive = false;
        this._ngbModalRef.close(result);
    }
    /**
     * Se utiliza para descartar una modal, pasando una razón de manera opcional
     */
    dismiss(reason) {
        this._isAlive = false;
        this._ngbModalRef.dismiss(reason);
    }
    /**
     * Define los botones que se muestran en la modal
     * @param buttons Los botones que se muestran en la modal
     */
    setButtons(buttons) {
        this.modalContainer.buttons = buttons;
    }
    /**
     * Promesa que se resuelve cuando una modal es cerrada, y se rechaza cuando una modal es descartada
     */
    get result() {
        return this._ngbModalRef.result;
    }
    /**
     * La instancia del contenedor de la modal. Es undefined cuando el content de la modal es un TemplateRef
     */
    get modalContainer() {
        return this._ngbModalRef.componentInstance;
    }
    /**
     * Permite saber si la modal está aun ejecutandose o se ha cerrado
     */
    get isAlive() {
        return this._isAlive && this._ngbModalRef && this._ngbModalRef.componentInstance;
    }
}

/**
 * @ignore
 */
class ModalContainerComponent {
    constructor(_activeModal, _cdRef, _elRef) {
        this._activeModal = _activeModal;
        this._cdRef = _cdRef;
        this._elRef = _elRef;
        this.title = null;
        this.contentTemplate = null;
        this.dataTemplate = null;
        this.contentComponent = null;
        this.contentText = null;
        this.modalRef = null;
        this._description = null;
        this._buttons = null;
        this._canClose = true;
        this._contentComponentRef = null;
    }
    ngAfterViewInit() {
        let autoFocus = this._elRef.nativeElement.querySelector('[ngwkAutofocus]');
        if (autoFocus) {
            let autoFocusElement = autoFocus.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (autoFocusElement) {
                autoFocusElement.focus();
                this._cdRef.detectChanges();
            }
        }
    }
    onContentComponentAttached(compRef) {
        this._contentComponentRef = compRef;
    }
    contentComponentInstance() {
        return this._contentComponentRef ? this._contentComponentRef.instance : null;
    }
    onButtonIsDisable(btn) {
        return btn && Type.isFunction(btn.isEnable) ? !btn.isEnable(btn) : false;
    }
    onButtonIsLoading(btn) {
        return btn && Type.isFunction(btn.isLoading) ? btn.isLoading(btn) : false;
    }
    getButtonContent(content) {
        if (Type.isFunction(content)) {
            return content();
        }
        else if (Str.isString(content)) {
            return content;
        }
    }
    onButtonClick(btn) {
        if (btn && btn.onClick) {
            btn.onClick();
        }
    }
    get contextTemplate() {
        return {
            $implicit: this.dataTemplate,
            context: this.dataTemplate
        };
    }
    get buttons() {
        return this._buttons;
    }
    set buttons(value) {
        this._buttons = value;
        this._cdRef.detectChanges();
    }
    get canClose() {
        return this._canClose;
    }
    set canClose(value) {
        this._canClose = value;
        this._cdRef.detectChanges();
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
        this._cdRef.detectChanges();
    }
    get showHeader() {
        return this.canClose || !!this.title;
    }
}
ModalContainerComponent.ɵfac = function ModalContainerComponent_Factory(t) { return new (t || ModalContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ModalContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalContainerComponent, selectors: [["ng-component"]], decls: 7, vars: 5, consts: [[1, "modalGrid", "verticalLayout"], ["class", "modal-header", 4, "ngIf"], [1, "modal-body"], ["id", "modalContentTemplate", "style", "width: 100%;", 4, "ngIf"], ["id", "modalContentComponent", "style", "width: 100%;", 4, "ngIf"], ["id", "modalContentText", "style", "width: 100%;", 4, "ngIf"], ["class", "modal-footer", 4, "ngIf"], [1, "modal-header"], [1, "alertWarning"], ["key", "exclamation", 1, "colAuto"], [1, "alertError"], ["key", "closeIcon", 1, "colAuto"], [1, "colAvailable", "verticalLayout"], [1, "rowAuto", "alignVerticalMiddle"], ["id", "modalMsgTitle", 1, "modal-title"], ["class", "rowAuto alignVerticalMiddle", 4, "ngIf"], ["type", "button", "class", "close pull-right colAuto", "aria-label", "Close", 3, "click", 4, "ngIf"], ["id", "modalMsgDescription", 1, "modal-description"], ["type", "button", "aria-label", "Close", 1, "close", "pull-right", "colAuto", 3, "click"], ["key", "closeIcon", 1, "colAuto", "modal-close"], ["id", "modalContentTemplate", 2, "width", "100%"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["id", "modalContentComponent", 2, "width", "100%"], [3, "cdkPortalOutlet", "attached"], ["id", "modalContentText", 2, "width", "100%"], ["id", "modalMsgMessage"], [1, "modal-footer"], [3, "id", "ngWKProgressButton", "disabled", "ngClass", "click", 4, "ngFor", "ngForOf"], [3, "id", "ngWKProgressButton", "disabled", "ngClass", "click"]], template: function ModalContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ModalContainerComponent_div_1_Template, 11, 3, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ModalContainerComponent_div_3_Template, 2, 2, "div", 3);
        ɵngcc0.ɵɵtemplate(4, ModalContainerComponent_div_4_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, ModalContainerComponent_div_5_Template, 3, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, ModalContainerComponent_div_6_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showHeader);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contentTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contentComponent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contentText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttons);
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.IconComponent, ɵngcc2.NgTemplateOutlet, ɵngcc4.CdkPortalOutlet, ɵngcc2.NgForOf, ɵngcc5.ProgressButtonDirective, ɵngcc2.NgClass], styles: [".modal[_ngcontent-%COMP%]{display:flex;flex-direction:column;width:100%;position:absolute}@media (min-width: 576px){.modal-dialog[_ngcontent-%COMP%]{max-width:500px!important}}.modal.fade[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{transform:none;transition:none}.modal-backdrop[_ngcontent-%COMP%]{position:absolute;width:100%;height:100%}.modalGrid[_ngcontent-%COMP%]{height:100%;display:flex}.modal-header[_ngcontent-%COMP%]{color:#f38642;border-bottom:none;padding:14px 5px 0 16px}.modal-header[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{margin:-14px -4px -16px auto}.modal-body[_ngcontent-%COMP%]{padding:10px 16px 5px;font-size:13px;color:#373737;display:flex;overflow-y:auto;overflow-x:hidden}.modal-content[_ngcontent-%COMP%]{border:none;box-shadow:0 0 15px 5px #0000001a;z-index:1590}.modal-footer[_ngcontent-%COMP%]{border-top:none;grid-row:3;padding:10px 16px}.modal-title[_ngcontent-%COMP%]{font-size:18px!important}.modal-description[_ngcontent-%COMP%]{font-size:13px;color:#666;margin-top:5px}.modal-close[_ngcontent-%COMP%]{cursor:pointer;background-color:transparent}.modalLateral[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]{margin:0 0 5px}.modalLateral[_ngcontent-%COMP%]   .modal-dialog-centered[_ngcontent-%COMP%]{align-items:normal;position:absolute;right:0;bottom:0;height:100%}.modalLateral[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{width:300px;margin:0}.modalLateral[_ngcontent-%COMP%]   .modal-content[_ngcontent-%COMP%]{height:100%;border-radius:0;z-index:1590}.serviceCodeModal[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]{background-color:#0081c6;margin:0;padding:0;border-radius:0}.serviceCodeModal[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]   .modal-title[_ngcontent-%COMP%]{color:#fff}.serviceCodeModal[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{color:#fff;opacity:1}.serviceCodeModal[_ngcontent-%COMP%]   .modal-body[_ngcontent-%COMP%]{margin:0;padding:0!important;overflow-y:hidden!important}.serviceCodeModal[_ngcontent-%COMP%]   .modal-dialog[_ngcontent-%COMP%]{width:auto;margin:0}.alertWarning[_ngcontent-%COMP%]{display:none;position:absolute;top:5px;left:-45px;z-index:-1;background-color:#ffa853;color:#fff;height:45px;width:45px}.alertWarning[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{border:3px solid white;font-size:16px;height:24px;width:24px;border-radius:100%}.alertError[_ngcontent-%COMP%]{display:none;position:absolute;top:5px;left:-45px;z-index:-1;background-color:#fb7e5d;color:#fff;height:45px;width:45px}.alertError[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{border:3px solid white;font-size:16px;height:24px;width:24px;border-radius:100%}.warningAlert[_ngcontent-%COMP%]   .alertWarning[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;display:flex!important}.errorAlert[_ngcontent-%COMP%]   .alertError[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;display:flex!important}@media (min-width: 576px){.modal-lg[_ngcontent-%COMP%]{max-width:800px!important;margin:1.75rem 1rem!important}}@media (min-width: 834px){.modal-lg[_ngcontent-%COMP%]{max-width:800px;margin:1.75rem auto!important}}"] });
/** @nocollapse */
ModalContainerComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalContainerComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"modalGrid verticalLayout\">\r\n  <div *ngIf=\"showHeader\" class=\"modal-header\">\r\n\r\n    <div class=\"alertWarning\">\r\n      <ucc-icon class='colAuto' key='exclamation'></ucc-icon>\r\n    </div>\r\n\r\n    <div class=\"alertError\">\r\n      <ucc-icon class='colAuto' key='closeIcon'></ucc-icon>\r\n    </div>\r\n    \r\n    <div class=\"colAvailable verticalLayout\">\r\n      <div class=\"rowAuto alignVerticalMiddle\">\r\n        <span id=\"modalMsgTitle\" class=\"modal-title\">{{title}}</span>\r\n      </div>\r\n      <div *ngIf=\"description\" class=\"rowAuto alignVerticalMiddle\">\r\n        <span id=\"modalMsgDescription\" class=\"modal-description\">{{description}}</span>\r\n      </div>\r\n    </div>\r\n\r\n    <button *ngIf=\"canClose\" type=\"button\" class=\"close pull-right colAuto\" aria-label=\"Close\" (click)=\"modalRef.dismiss('Cross click')\">\r\n      <ucc-icon class='colAuto modal-close' key='closeIcon'></ucc-icon>\r\n    </button>\r\n\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <div id=\"modalContentTemplate\" *ngIf=\"contentTemplate\" style=\"width: 100%;\">\r\n      <ng-container *ngTemplateOutlet=\"contentTemplate;context:contextTemplate\"></ng-container>\r\n    </div>\r\n    <div id=\"modalContentComponent\" *ngIf=\"contentComponent\" style=\"width: 100%;\">\r\n      <ng-container [cdkPortalOutlet]=\"contentComponent\" (attached)=\"onContentComponentAttached($event)\"></ng-container>\r\n    </div>\r\n    <div id=\"modalContentText\" *ngIf=\"contentText\" style=\"width: 100%;\">\r\n      <span id=\"modalMsgMessage\">{{contentText}}</span>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"buttons\" class=\"modal-footer\">\r\n    <button *ngFor=\"let button of buttons\" [id]=\"button.id ? button.id : '' \" (click)=\"onButtonClick(button)\" [ngWKProgressButton]=\"onButtonIsLoading(button)\" [disabled]=\"onButtonIsDisable(button)\" [ngClass]=\"button.style\">{{getButtonContent(button.content)}}</button>\r\n  </div>\r\n</div>\r\n",
                styles: [".modal{display:flex;flex-direction:column;width:100%;position:absolute}@media (min-width: 576px){.modal-dialog{max-width:500px!important}}.modal.fade .modal-dialog{transform:none;transition:none}.modal-backdrop{position:absolute;width:100%;height:100%}.modalGrid{height:100%;display:flex}.modal-header{color:#f38642;border-bottom:none;padding:14px 5px 0 16px}.modal-header .close{margin:-14px -4px -16px auto}.modal-body{padding:10px 16px 5px;font-size:13px;color:#373737;display:flex;overflow-y:auto;overflow-x:hidden}.modal-content{border:none;box-shadow:0 0 15px 5px #0000001a;z-index:1590}.modal-footer{border-top:none;grid-row:3;padding:10px 16px}.modal-title{font-size:18px!important}.modal-description{font-size:13px;color:#666;margin-top:5px}.modal-close{cursor:pointer;background-color:transparent}.modalLateral .modal-header{margin:0 0 5px}.modalLateral .modal-dialog-centered{align-items:normal;position:absolute;right:0;bottom:0;height:100%}.modalLateral .modal-dialog{width:300px;margin:0}.modalLateral .modal-content{height:100%;border-radius:0;z-index:1590}.serviceCodeModal .modal-header{background-color:#0081c6;margin:0;padding:0;border-radius:0}.serviceCodeModal .modal-header .modal-title{color:#fff}.serviceCodeModal .modal-header .close{color:#fff;opacity:1}.serviceCodeModal .modal-body{margin:0;padding:0!important;overflow-y:hidden!important}.serviceCodeModal .modal-dialog{width:auto;margin:0}.alertWarning{display:none;position:absolute;top:5px;left:-45px;z-index:-1;background-color:#ffa853;color:#fff;height:45px;width:45px}.alertWarning i{border:3px solid white;font-size:16px;height:24px;width:24px;border-radius:100%}.alertError{display:none;position:absolute;top:5px;left:-45px;z-index:-1;background-color:#fb7e5d;color:#fff;height:45px;width:45px}.alertError i{border:3px solid white;font-size:16px;height:24px;width:24px;border-radius:100%}.warningAlert .alertWarning{display:flex;align-items:center;justify-content:center;display:flex!important}.errorAlert .alertError{display:flex;align-items:center;justify-content:center;display:flex!important}@media (min-width: 576px){.modal-lg{max-width:800px!important;margin:1.75rem 1rem!important}}@media (min-width: 834px){.modal-lg{max-width:800px;margin:1.75rem auto!important}}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.NgbActiveModal }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, null); })();

/**
 * Este servicio sirve para la gestión de modales en la aplicación. Se pueden declarar modales pasándole simplemente strings,
 * templates o incluso componentes. Se deben definir unas [INgwkModalOptions]{@link INgwkModalOptions} para poder personalizar
 * la modal. Dentro de la modal creada, si es de tipo Component, se puede acceder a los datos y a la referencia de ésta a través
 * de [INgwkModalParams]{@link INgwkModalParams}
 */
class ModalService {
    /** @ignore */
    constructor(_modalService, _injector, _router) {
        this._modalService = _modalService;
        this._injector = _injector;
        this._router = _router;
        this._activeModal = null;
        this._activeLateralModal = null;
        _router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e) => this.closeLateralModal());
    }
    /**
     * Método para la declaración de una modal estándar. Se le debe pasar un contenido de tipo string, Template o Component.
     * También se le debe pasar un título y, de manera opcional, unas opciones para cambiar las estándar que tiene predeterminadas
     * la modal. Las opciones son de tipo [INgwkModalOptions]{@link INgwkModalOptions}
     *
     * @param content Contenido de la modal. Puede ser de tipo string, Template y Component
     * @param title Título de la modal
     * @param options Opciones de la modal
     * @param description Descripción de la modal. Aparece en el header, justo debajo del title
     */
    show(content, title = null, options, description) {
        let thirdPartyModalRef = this._modalService.open(ModalContainerComponent, this.getOptions(options));
        let ownModalRef = this.customizeModal(thirdPartyModalRef, title, content, options, description);
        this._activeModal = ownModalRef;
        this.applyZIndex();
        return ownModalRef;
    }
    /**
     * Método para la declaración de una modal custom. Se le debe pasar un contenido de tipo string, Template o Component.
     * De manera opcional se le pueden pasar unas opciones para cambiar las estándar que tiene predeterminadas
     * la modal. Las opciones son de tipo [INgwkModalOptions]{@link INgwkModalOptions}.
     * Esta modal se diferencia de la estándar y de la lateral por ser totalmente personalizable, sin tener un header, content
     * y footer predefinidos. El header no se centra en un solo título y el footer no se centra en únicamente contener botones,
     * y se les puede definir el contenido que se desee.
     *
     * @param content Contenido de la modal. Puede ser de tipo string, Template y Component
     * @param title Título de la modal
     * @param options Opciones de la modal
     */
    showCustom(content, options) {
        let thirdPartyModalRef = this._modalService.open(content, this.getOptions(options));
        let ownModalRef = new NgwkModalRef(thirdPartyModalRef);
        if (options && options.data) {
            ownModalRef.modalContainer.data = options.data;
        }
        ownModalRef.modalContainer.modalRef = ownModalRef;
        this._activeModal = ownModalRef;
        this.applyZIndex();
        return ownModalRef;
    }
    /**
     * Método para la declaración de una modal lateral que ocupa la zona navegación.
     * Se le debe pasar un contenido de tipo string, Template o Component.
     * También se le debe pasar un título y, de manera opcional, unas opciones para cambiar las estándar que tiene predeterminadas
     * la modal. Las opciones son de tipo [INgwkModalOptions]{@link INgwkModalOptions}
     * Esta modal es igual que la estándar, pero tiene una clase extra que le hace aparecer en un lateral de la pantalla
     *
     * @param content Contenido de la modal. Puede ser de tipo string, Template y Component
     * @param title Título de la modal
     * @param options Opciones de la modal
     * @param description Descripción de la modal. Aparece en el header, justo debajo del title
     */
    showLateral(content, title = null, options, description, container = '#modal-lateral-container') {
        const thirdPartyOptions = this.getOptions(options);
        thirdPartyOptions.windowClass = `modalLateral${thirdPartyOptions.windowClass ? ` ${thirdPartyOptions.windowClass}` : ''}`;
        thirdPartyOptions.container = container;
        const thirdPartyModalRef = this._modalService.open(ModalContainerComponent, thirdPartyOptions);
        const ownModalRef = this.customizeModal(thirdPartyModalRef, title, content, options, description);
        this._activeLateralModal = ownModalRef;
        this.applyZIndex();
        return ownModalRef;
    }
    /**
     * Método para la declaración de una modal lateral que ocupe todo el alto de la ventana.
     * Se le debe pasar un contenido de tipo string, Template o Component.
     * También se le debe pasar un título y, de manera opcional, unas opciones para cambiar las estándar que tiene predeterminadas
     * la modal. Las opciones son de tipo [INgwkModalOptions]{@link INgwkModalOptions}
     * Esta modal es igual que la estándar, pero tiene una clase extra que le hace aparecer en un lateral de la pantalla
     *
     * @param content Contenido de la modal. Puede ser de tipo string, Template y Component
     * @param title Título de la modal
     * @param options Opciones de la modal
     * @param description Descripción de la modal. Aparece en el header, justo debajo del title
     */
    showFullLateral(content, title = null, options, description) {
        return this.showLateral(content, title, options, description, '#modal-full-lateral-container');
    }
    applyZIndex() {
        // setTimeout to allow the correct applycation of zIndex after modal window and modal backdrop components are generated on the DOM
        setTimeout(() => {
            const modalBackdropElements = document.querySelectorAll(".modal-backdrop");
            modalBackdropElements.forEach((backdropElement, position) => backdropElement.style.zIndex = `${1589 + position * 20}`);
            const modalElements = document.querySelectorAll(".modal");
            modalElements.forEach((modalElement, position) => modalElement.style.zIndex = `${1590 + position * 20}`);
        });
    }
    customizeModal(thirdPartyModalRef, title, content, options, description) {
        let ownModalRef = new NgwkModalRef(thirdPartyModalRef);
        ownModalRef.modalContainer.title = title;
        ownModalRef.modalContainer.modalRef = ownModalRef;
        ownModalRef.modalContainer.canClose = options
            ? options.canClose !== false
            : true;
        this.setModalContent(ownModalRef, content, options, description);
        return ownModalRef;
    }
    setModalContent(modalRef, content, options, description) {
        if (Str.isString(content)) {
            modalRef.modalContainer.contentText = content;
        }
        else if (content instanceof TemplateRef) {
            modalRef.modalContainer.dataTemplate = options ? options.data : null;
            modalRef.modalContainer.contentTemplate = content;
        }
        else {
            modalRef.modalContainer.contentComponent = new ComponentPortal(content, null, this.getInjector(options, modalRef));
        }
        if (options && options.buttons) {
            modalRef.setButtons(options.buttons);
        }
        if (description) {
            modalRef.modalContainer.description = description;
        }
    }
    getOptions(options) {
        let ngbOptions = {};
        if (options) {
            ngbOptions.keyboard = options.canClose;
            ngbOptions.windowClass = options.windowClass;
            if (options.size) {
                ngbOptions.size = options.size;
            }
        }
        return Object.assign(Object.assign({}, DEFAULT_NGBOPTIONS), ngbOptions);
    }
    getInjector(options, modalRef) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(MODAL_PARAMS, {
            data: options ? options.data : null,
            modalRef: modalRef
        });
        return new PortalInjector(this._injector, injectionTokens);
    }
    closeLateralModal() {
        if (this._activeLateralModal) {
            this._activeLateralModal.dismiss('NavigationEnd');
            this._activeLateralModal = null;
        }
    }
    /** @ignore */
    get activeLateralModal() {
        return this._activeLateralModal;
    }
    /** @ignore */
    get activeModal() {
        return this._activeModal;
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(ɵngcc1.NgbModal), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc6.Router)); };
ModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac });
/** @nocollapse */
ModalService.ctorParameters = () => [
    { type: NgbModal },
    { type: Injector },
    { type: Router }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.NgbModal }, { type: ɵngcc0.Injector }, { type: ɵngcc6.Router }]; }, null); })();
/** @ignore */
const DEFAULT_NGBOPTIONS = {
    keyboard: true,
    centered: true,
    backdrop: 'static'
};
/** @ignore */
const MODAL_PARAMS = new InjectionToken('MODAL_PARAMS');

class ModalModule {
}
ModalModule.ɵfac = function ModalModule_Factory(t) { return new (t || ModalModule)(); };
ModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ModalModule });
ModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [ModalService], imports: [[
            CommonModule,
            IconModule,
            PortalModule,
            NgbModalModule,
            ProgressButtonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalModule, [{
        type: NgModule,
        args: [{
                declarations: [ModalContainerComponent],
                entryComponents: [ModalContainerComponent],
                imports: [
                    CommonModule,
                    IconModule,
                    PortalModule,
                    NgbModalModule,
                    ProgressButtonModule
                ],
                providers: [ModalService],
                schemas: [NO_ERRORS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule, { declarations: function () { return [ModalContainerComponent]; }, imports: function () { return [CommonModule,
        IconModule,
        PortalModule,
        NgbModalModule,
        ProgressButtonModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MODAL_PARAMS, ModalContainerComponent, ModalModule, ModalService, NgwkModalRef };

